                                                                                                     import SoilMenuItem from './SoilMenuItem';

export default SoilMenuItem;